import React from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import proptypes from 'prop-types';
import classNames from 'classnames';

const { bool } = proptypes;

const DESKTOP_LOADER_HEIGHT = 'sui-h-[650px]';

export const MediaGalleryLoader = ({ isMobile, isCarousel = false }) => {
  return (
    <LoadingPlaceholder
      type={isCarousel ? 'rect' : 'mediaGallery'}
      ready={false}
      color="#E0E0E0"
      showLoadingAnimation
      className={classNames({
        [DESKTOP_LOADER_HEIGHT]: !isCarousel && !isMobile,
        'sui-h-72': !isCarousel && isMobile,
        'sui-p-2': !isCarousel && !isMobile,
        'sui-w-full sui-aspect-square sui-mb-[30px]': isCarousel
      })}
      rows={0}
      isMobile={isMobile}
    >
      Media Loader
    </LoadingPlaceholder>
  );
};

MediaGalleryLoader.displayName = 'MediaGalleryLoader';

MediaGalleryLoader.propTypes = {
  isMobile: bool.isRequired,
  isCarousel: bool
};
